package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.Res
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.backgroundImage
import org.jetbrains.compose.web.css.backgroundPosition
import org.jetbrains.compose.web.css.backgroundRepeat
import org.jetbrains.compose.web.css.backgroundSize
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.paddingLeft
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span

@Composable
fun LoadingProgress(
    modifier: Modifier = Modifier,
    visibility: Boolean = false,
    fillAll:Boolean=true,
    loadingTitle: String = "",
) {
    val largePadding = Dimen.mediumPadding.value.toInt()

    if (visibility) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .position(Position.Relative)
        ) {
            Box(
                modifier = modifier
                    .thenIf(
                        fillAll,
                        modifier
                            .position(Position.Absolute)
                            .top((-largePadding).px)
                            .left((-largePadding).px)
                            .right((-largePadding).px)
                            .bottom((-largePadding).px)
                    )
                    .thenIf(
                        !fillAll,
                        modifier
                            .position(Position.Absolute)
                            .top(0.px)
                            .left(0.px)
                            .right(0.px)
                            .bottom(0.px)
                    )
                    .borderRadius(Dimen.semiLargeRadius)
                    .backgroundColor(Theme.ActionDisabledBackground.rgb)
                    .zIndex(Constants.ZIndex.largeZIndex),
                contentAlignment = Alignment.Center
            ) {
                Div(
                    attrs = {
                        style {
                            backgroundImage(Res.PathIcon.wawiloading)
                            width(Dimen.loadingSize)
                            height(Dimen.loadingSize)
                            backgroundSize("contain")
                            backgroundRepeat("no-repeat")
                            backgroundPosition("center")
                        }
                    }
                )

                if (loadingTitle.isNotEmpty()) {
                    SpanText(
                        text = loadingTitle,
                        modifier = Modifier
                            .margin(top = Dimen.smallPadding)
                            .fontWeight(FontWeight.Medium)
                            .fontFamily(FontFamily.Jakarta)
                            .color(Theme.PrimaryDark.rgb)
                            .fontSize(FontSizes.normalFontSize)
                    )
                }
            }
        }
    }
}

@Composable
fun CircularProgress(
    modifier: Modifier = Modifier,
    color: CSSColorValue = Theme.PrimaryMain.rgb,
    size: CSSSizeValue<CSSUnit.px>,
    borderWidth: CSSSizeValue<CSSUnit.px> = Dimen.mediumThickness,
) {
    Box(
        modifier = modifier
    ) {
        Div(
            attrs = Modifier
                .classNames("spinner-border")
                .styleModifier {
                    property("border-color", color.toString())
                    property("border-top-color", "transparent")
                    property("border-width", borderWidth.toString())
                    width(size)
                    height(size)
                }
                .toAttrs()
        ) {
            Span(
                attrs = Modifier
                    .classNames("visually-hidden")
                    .toAttrs()
            )
        }
    }
}

